<!-- eslint-disable -->
<template lang="pug">
    div(v-if="errorStatus === 403")
        | {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
    profile-preview(v-else-if="!isLoading && school")
        template(slot="left")
            img.profile__avatar(:src="school.avatar")
            .profile__name
                | {{ school.name }}
            .profile__items
                .profile__box
                    .profile__send-message-container
                        cs-button.profile__send-message(
                            color="white",
                            :full-width="true",
                            @click="switchModal('message')"
                        )
                            | {{ $i18n.t('profiles.profiles_user_sendMessage') }}
                    .profile__item.profile__item--size
                        svg-icon.profile__icon.profile__icon--small(
                            v-if="school.status === 'active'",
                            name="check",
                            height="18px",
                            width="14px"
                        )
                        svg-icon.profile__icon.profile__icon--small(
                            v-else
                            name="times"
                            size="small"
                        )
                        .profile__text
                            .profile__text--header {{ $i18n.t('profiles.profiles_profile_status') }}
                            div {{ statusString }}
                    .profile__item.profile__item--size(v-if="tariffString")
                        svg-icon.profile__icon(name="book", size="large")
                        .profile__text
                            .profile__text--header {{ $i18n.t('profiles.profiles_profile_tariff') }}
                            div {{ tariffString }}
                    .profile__item.profile__item--size(v-if="!school.studentPayed && school.isBillingActive")
                        svg-icon.profile__icon.profile__icon--small(
                            v-if="school.account.status",
                            name="check",
                            height="18px",
                            width="14px"
                        )
                        svg-icon.profile__icon.profile__icon--small(
                            v-else
                            name="times"
                            size="small"
                        )
                        .profile__text
                            .profile__text--header {{ $i18n.t('profiles.profiles_profile_accountStatus') }}
                            div
                                div {{ school.account && school.account.status ? $i18n.t('profiles.profiles_profile_statusActive') : $i18n.t('profiles.profiles_profile_statusBlocked') }}
                                div(v-if="user.isSuperadmin")
                                    a.profile__link(
                                        href="javascript://"
                                        @click="changeAccountStatus"
                                        :title="$i18n.t('profiles.profiles_user_buttonChange')"
                                    )
                                        | {{ $i18n.t('profiles.profiles_user_buttonChange') }}
                                div(v-if="isActivateAccountButtonShown && isEnoughMoneyForActivation")
                                    a.profile__link(
                                        href="javascript://"
                                        @click="activateAccount"
                                        :title="$i18n.t('profiles.profiles_school_buttonActivateAccount')"
                                    )
                                        | {{ $i18n.t('profiles.profiles_school_buttonActivateAccount') }}
                    .profile__item.profile__item--size
                        svg-icon.profile__icon(name="phone", size="large")
                        .profile__text
                            .profile__text--header {{ $i18n.t('profiles.profiles_profile_phone') }}
                            div {{ school.phone }}
                    .profile__item.profile__item--size(v-for="location in school.locations")
                        svg-icon.profile__icon(name="pin", size="large")
                        .profile__text
                            .profile__text--header(v-text="location.isMain ? $i18n.t('profiles.profiles_school_primaryAddress') : $i18n.t('profiles.profiles_school_branch')")
                            div {{ location.city }}, {{ location.address }}
        template(slot="right")
            .info__buttons
                cs-button.info__button(
                    v-if="isEditable"
                    @click="$router.push({name: 'school:edit'})"
                    color="green"
                )
                    | {{ $i18n.t('profiles.profiles_profile_edit') }}
                cs-button.info__button(
                    v-else-if="this.school.status === 'archived' && this.user.isSuperadmin"
                    @click="restoreSchool"
                    color="green"
                )
                    | {{ $i18n.t('profiles.profiles_profile_restore') }}
            .info__item(v-if="school.mainContact")
                .info__item-header
                    |  {{ $i18n.t('profiles.profiles_school_primaryContact') }}
                hr.info__divider
                .main-contact
                    small-user-preview(:displayed-user="school.mainContact")
            .info__item(v-if="isBillingShown")
                .info__item-header
                    | {{ $i18n.t('billing.billing_settings_balance') }}
                hr.info__divider
                .billing
                    .billing__item.billing__balance
                        div
                            | {{ $i18n.t('billing.billing_settings_balance') }}:&nbsp;
                            span.billing__value {{ balanceString }}
                        a.billing__link(href="javascript://", @click="switchModal('balance')", v-if="user.isSuperadmin || userIsSchoolAdmin")
                            | {{ $i18n.t('billing.billing_updateBalance') }}
                    hr.info__divider
                    .billing__item.billing__month-payment(@click="showMonthPayment = !showMonthPayment")
                        .month-payment__cost
                            span {{ $i18n.t('billing.billing_settings_activationCost') }}:&nbsp;
                            span.billing__value {{ monthPaymentString }}
                        svg-icon.angle__icon(
                            name="angle",
                            height="9px", width="14px",
                            :class="{'angle__icon--inverse': showMonthPayment}"
                        )
                    transition(name="slide").month-payment__expanded(v-if="showMonthPayment")
                        div.month-payment__wrapper(v-if="!isSummaryLoading" :style="stylesMonthPaymentWrapper")
                            table.month-payment__table
                                thead.month-payment__thead
                                    tr.month-payment__tr
                                        td.month-payment__td  {{ $i18n.t('profiles.profiles_school_students') }}
                                        td.month-payment__td  {{ $i18n.t('billing.billing_settings_free_slots') }}
                                tbody.month-payment__tbody
                                    tr.month-payment__tr.month-payment__tr--border
                                        td.month-payment__td  {{ monthPayment.studentsCount }}
                                        td.month-payment__td  {{ school.studentFreeSlots || 0 }}
                                thead.month-payment__thead(v-if="monthPayment.teachers")
                                    tr.month-payment__tr
                                        td.month-payment__td {{ $i18n.t('dashboard.dashboard_appHeader_teachers') }}
                                        td.month-payment__td  {{ $i18n.t('billing.billing_settings_free_slots') }}
                                tbody.month-payment__tbody(v-if="monthPayment.teachers")
                                    tr.month-payment__tr.month-payment__tr--border
                                        td.month-payment__td  {{ monthPayment.teachersCount}}
                                        td.month-payment__td  {{ monthPayment.teachers.freeTeachersAmount }}
                        cs-loader(v-else)
                    template(v-if="isDateOfNextPaymentShown")
                        hr.info__divider
                        .billing__item
                            | {{ $i18n.t('billing.billing_settings_dateOfNextPayment') }}:
                            | {{ school.dateOfNextPayment }}
                    template(v-if="isBillingShown && !isEnoughMoneyForActivation")
                        hr.info__divider
                        .billing__item.billing__item--error
                            span {{ $i18n.t('billing.billing_notEnoughMoneyForActivation') }}&nbsp;
                            span.billing__value {{ moneyForActivationString }}
            .info__item(v-if="summariesMonthPayments.current.isSubscription || summariesMonthPayments.next.isSubscription")
                .info__item-header
                    | {{ $i18n.t('list.list_billing_subscription') }}
                div(v-if="summariesMonthPayments.current.isSubscription")
                    hr.info__divider
                    .billing__item(@click="isShowCurrentMonthPayment = !isShowCurrentMonthPayment")
                        span
                            | {{ $i18n.t('elements.elements_datePicker_currentMonth') }}
                        svg-icon.angle__icon(
                            name="angle",
                            height="9px", width="14px",
                            :class="{'angle__icon--inverse': isShowCurrentMonthPayment}"
                        )
                    .billing__item(v-for="(courseData, course) in coursesWithMaxStudents('current')", v-if="isShowCurrentMonthPayment")
                        | {{ $i18n.t('common.common_course_' + course) + ': '}}
                        | {{ courseData.studentsAmount + '/' + courseData.maxStudentsAmount + ' ' }}
                        | {{ $i18n.t('declination.declination_student_list') }}
            .info__item(v-if="user.type === 'admin' || user.isSuperadmin || user.isManagerOrSupport")
                .info__item-header
                    | {{ $i18n.t('profiles.profiles_school_availableCourses') }}
                    span.info__item-header--light {{ school.courses.length }}
                hr.info__divider
                .row.courses
                    .col-xs-12.col-md-6(v-for="course in school.courses")
                        .course
                            svg-icon.course__icon(name="book", size="large")
                            .course__info
                                router-link.course__name(
                                    :to="{name: 'course:profile', params: {id: course.id}}"
                                )
                                    | {{ course.name }}
            .info__item
                .info__item-header
                    | {{ $i18n.t('profiles.profiles_school_admins') }}
                    span.info__item-header--light {{ school.admins.length }}
                hr.info__divider
                .admins(v-if="school.admins && school.admins.length > 0")
                    .row
                        .col-xs-12.col-md-6.admin(v-for="admin in school.admins")
                            small-user-preview(:displayed-user="admin")
            .info__item
                .info__item-header
                    | {{ $i18n.t('profiles.profiles_school_teachers') }}
                    span.info__item-header--light {{ school.teachers.length }}
                hr.info__divider
                .teachers(v-if="school.teachers && school.teachers.length > 0")
                    .row
                        .col-xs-12.col-md-6.teacher(v-for="teacher in school.teachers")
                            small-user-preview(:displayed-user="teacher")
            .info__item
                .info__item-header
                    | {{ $i18n.t('profiles.profiles_school_students') }}
                    span.info__item-header--light {{ amountOfStudentsSchool }}
                hr.info__divider
                .students(v-if="school.students && school.students.length > 0")
                    .row
                        .col-xs-12.col-md-6.student(v-for="student in school.students")
                            small-user-preview(:displayed-user="student")
                    .row
                        cs-button.students__button(
                            color="blue"
                            pattern="primary-outline"
                            @click="$router.push({name: 'user:list', params: {type: 'student'}, query: {schoolId: id}})"
                        )
                            svg-icon.button__icon(name="tablet", size="large")
                            | {{ $i18n.t('profiles.profiles_profile_openList') }}
        create-message-modal(
            v-if="showMessageModal"
            @close="showMessageModal = false"
            @send="sendMessage"
            :receivers="users"
            :name="school.name"
            :school-id="school.id"
        )
        account-balance-modal(
            v-if="showBalanceModal && user.type === 'admin'"
            @close="switchModal('balance')"
            @balance="school.account.balance = Math.round((arguments[0] + school.account.balance) * 100) / 100"
            :profile="school"
        )
        cs-modal(
            v-if="showZeroForksModal"
            @close="showZeroForksModal = false"
        )
            .zero-forks-modal__text(slot='header')
                | {{ $i18n.t('billing.billing_zero_forks_info') }}
    cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import SchoolApi from '../../api/school';
    import AccountApi from "../../api/billing/account";

    import ProfilePreview from './ProfilePreview.vue'
    import SmallUserPreview from './default-elements/SmallUserPreview.vue'

    import AccountBalanceModal from "../../modals/AccountBalanceModal.vue";
    import CreateMessageModal from '../../modals/CreateMessageModal.vue';

    import SendMessageMixin from '../../utils/communication/sendMessageMixin';
    import usersListMixin from "../../utils/user/usersListMixin";

    import {mapState} from 'vuex'
    import _ from 'lodash';

    export default {
        mixins: [SendMessageMixin, usersListMixin],
        data() {
            return {
                school: null,
                monthPayment: {sum: 0, courses: [], isStock: false, isSubscription: false},
                isLoading: false,
                isSummaryLoading: false,
                errorStatus: null,
                showMonthPayment: false,
                showMessageModal: false,
                showBalanceModal: false,
                showZeroForksModal: false,
                summariesMonthPayments: {current: {isSubscription: false}, next: {isSubscription: false}},
                isShowCurrentMonthPayment: false,
                isShowNextMonthPayment: false,
                freeSlotsForEachCourse: null,
                clientWidth: 0
            }
        },
        props: {
            id: {
                validator(value) {
                    const isNumberOrStringCastableToNumber = !isNaN(value);
                    return isNumberOrStringCastableToNumber;
                },
                required: true,
            },
            needsToShowZeroForksModal: {
                type: Boolean,
                default: false,
            }
        },
        created() {
            window.addEventListener('resize', this.onResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.onResize);
        },
        mounted() {
            if (this.needsToShowZeroForksModal) {
                this.showZeroForksModal = true;
            }
            this.fetchData();
            this.onResize();
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                isShowSidebar: state => state.isShowSidebar,
            }),
            freTeachersAmountString() {
                // temporary solution
                const activeFreeTeachersAmountStrung = this.school.status === 'active' ? this.monthPayment.teachers.activeFreeTeachersAmount : 0;
                if (this.monthPayment.teachers) {
                    return activeFreeTeachersAmountStrung + '/' + this.monthPayment.teachers.freeTeachersAmount;
                }
            },
            amountOfStudentsSchool() {
              return this.school.allStudentsCount
            },
            isEditable () {
                return this.school.status === 'active'
                        && (this.user.isSuperadmin || this.user.isManagerOrSupport)
                        || (this.user.type === 'admin' && _.find(this.user.schools, { id: this.school.id }));
            },
            users () {
                return this.school.admins.concat(this.school.teachers, this.school.allStudents).filter(user => user.id !== this.user.id)
            },
            balanceString () {
                if (this.school.account) {
                    return this.numberInPaymentString(this.school.account.balance);
                }
                return "";
            },
            userIsSchoolAdmin () {
                return this.school.mainContactId === this.user.id;
            },
            monthPaymentString () {
                if (this.monthPayment) {
                    return this.numberInPaymentString(this.monthPayment.sum);
                }
                return "";
            },
            moneyForActivationString () {
                if (this.school.account && this.monthPayment) {
                    let amount = Math.round((this.monthPayment.sum - this.school.account.balance) * 100) / 100;
                    return this.numberInPaymentString(amount);
                }
                return "";
            },
            isEnoughMoneyForActivation () {
                if (this.school.account && !this.school.account.status && this.monthPayment) {
                    return this.monthPayment.sum - this.school.account.balance <= 0;
                }
                return true;
            },
            isBillingShown () {
                return (this.user.isSuperadmin || this.user.isManagerOrSupport
                        || (this.userIsSchoolAdmin && !this.school.studentPayed))
                        && this.school.isBillingActive;
            },
            isDateOfNextPaymentShown () {
                return ((this.user.isSuperadmin || this.userIsSchoolAdmin) && this.school.account.status)
                        && this.school.isBillingActive && this.school.dateOfNextPayment
            },
            statusString () {
                return this.$i18n.t('profiles.profiles_profile_status' + _.capitalize(this.school.status))
            },
            tariffString () {
                return this.school.tariffId
                        ? this.$i18n.t('billing.billing_tariff_' + this.school.tariffId)
                        : '';
            },
            isActivateAccountButtonShown() {
                return (this.user.type === 'admin' && !this.user.isSuperadmin) && this.userIsSchoolAdmin && !this.school.account.status;
            },
            isShowButton () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            },
            stylesMonthPaymentWrapper() {
                let width = 'inherit';
                if(this.clientWidth >= 1200) {
                    if(!this.isShowSidebar) {
                        width = 'calc(100vw - 665px)';
                    } else {
                        width = 'calc(100vw - 860px)';
                    }
                } else if(this.clientWidth >= 768) {
                    width = 'calc(100vw - 265px)';
                }
                return {
                    'max-width': width
                };
            },
        },
        methods: {
            fetchData() {
                this.isLoading = true;
                SchoolApi.show(this.id)
                .then((data) => {
                    this.freeSlotsForEachCourse = data.studentFreeSlots;
                    this.school = data;
                    if (this.$route.params.withOpenedBalanceModal) {
                        this.showBalanceModal = true;
                    }
                    this.isLoading = false;
                    this.isSummaryLoading = true;
                    this.getSummary();
                })
                .catch(err => {
                    this.errorStatus = err.status;
                    this.isLoading = false;
                })
            },
            restoreSchool () {
                let coursesIds = this.school.courses.map(course => course.id)
                SchoolApi.update(this.id, {status: 'active', coursesIds})
                .then(school => {
                    this.school.status = school.status;
                });
            },
            changeAccountStatus () {
                this.school.account.status = !this.school.account.status;
                AccountApi.updateStatus(this.school.account.id, {status: Number(this.school.account.status)})
                .catch(err => this.$toasted.error(err.data.message));
            },
            activateAccount () {
                AccountApi.activateAccount(this.school.account.id)
                    .then(account => {
                        this.school.account = account;
                        this.$toasted.success(this.$i18n.t('profiles.profiles_school_account_activated'));
                    })
                    .catch(err => this.$toasted.error(err.data.message));
            },
            getSummary () {
                SchoolApi.getSummary(this.id)
                .then(data => {
                    this.monthPayment = data.monthPayment;
                    this.summariesMonthPayments = data.summariesMonthPayments;
                    this.addStudentFreeSlotsInCourseObject(this.monthPayment.courses);
                    this.isSummaryLoading = false;
                    this.showMonthPayment = true;
                })
                .catch(err => {
                    this.errorStatus = err.status;
                    this.isSummaryLoading = false;
                });
            },
            addStudentFreeSlotsInCourseObject(courses) {
                for (let key in this.freeSlotsForEachCourse) {
                    if (courses[key]) {
                        this.$set(courses[key], 'studentFreeSlots', this.freeSlotsForEachCourse[key]);
                    }
                }
            },
            numberInPaymentString (payment) {
                return payment + " " + this.$i18n.tc('olympiads.olympiads_olympiadForm_rubles', payment);
            },
            switchModal (name) {
                const showProperty = _.camelCase('show-' + name + '-modal');
                this[showProperty] = !this[showProperty];
            },
            coursesWithMaxStudents(type) {
                let courses = {};
                let monthPayment = type == 'current' ? this.summariesMonthPayments.current : this.summariesMonthPayments.next ;
                if (!(this.summariesMonthPayments && monthPayment.courses)) {
                    return courses;
                }
                for (let [key, value] of Object.entries(monthPayment.courses)) {
                    if (value.maxStudentsAmount) {
                        courses[key] = value;
                    }
                }
                return courses;
            },
            onResize() {
                this.clientWidth = document.documentElement.clientWidth;
            },
        },
        watch: {
            'school.account'() {
                this.getSummary();
            },
            deep: true
        },
        components: {
            SmallUserPreview,
            AccountBalanceModal,
            ProfilePreview,
            CreateMessageModal,
        }
    }
</script>

<style lang="scss" scoped>
    .profile__avatar {
        border-radius: 50%;
        max-height: none;
        height: 140px;
        width: 140px;
        border: 10px solid rgba($hsl-color-gray-100, 0.2);
    }

    .profile__name {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        color: $x-color-white;
        margin: 20px 0 30px;
        text-align: center;
    }

    .profile__items {
        width: 100%;
    }

    .profile__box {
        display: flex;
        flex-wrap: wrap;
        margin: 0 auto;

        max-width: 240px;
        @include media($md) {
            max-width: 100%;
        }
        @include media($xlg) {
            max-width: 240px;
        }
    }

    .profile__send-message-container {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .profile__send-message {
        max-width: 240px;
    }

    .profile__item {
        box-sizing: border-box;
        padding: 0;
        color: $x-color-white;
        display: flex;
        font-size: 18px;
        line-height: 24px;
        margin-top: 34px;
    }


    .profile__item--size {
        width: 100%;
        @include media($md) {
            width: 50%;
            &:nth-child(odd) {
                padding-right: 20px;
            }
        }
        @include media($xlg) {
            width: 100%;
        }
    }

    .profile__icon {
        padding-top: 5px;
        margin-right: 10px;
    }

    .profile__icon--small {
        margin-right: 16px;
    }

    .profile__text {
        display: flex;
        flex-direction: column;
    }

    .profile__text--header {
        font-weight: 500;
    }

    .profile__link {
        font-size: 18px;
        line-height: 26px;
        color: $x-color-white;
        text-decoration-line: underline;
    }

    .info__buttons {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin: 20px 0;
        @include media($lg) {
            margin: 0 0 20px;
            flex-direction: row;
            justify-content: flex-end;
        }
    }

    .info__button {
        margin-bottom: 10px;
        @include media($lg) {
            margin-left: 10px;
        }
    }

    .info__item {
        padding: 30px;
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        margin-bottom: 0;
        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .info__item-header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        display: flex;
        align-items: center;
    }

    .info__item-header--light {
        margin-left: 1rem;
        color: $hsl-color-gray-74;
    }

    .info__divider {
        border: 0;
        margin: 25px auto 0;
        background: $hsl-color-gray-74;
        height: 1px;
        width: 100%;
        &:last-child {
            display: none;
        }
    }

    .main-contact, .admin, .teacher, .student {
        display: flex;
        box-sizing: border-box;
        margin-top: 30px;
    }

    .course {
        display: flex;
        box-sizing: border-box;
        margin-top: 30px;
        &:nth-child(odd) {
            padding-right: 20px;
        }
    }

    .course__info {
        font-size: 16px;
        line-height: 24px;
        color: $x-color-black;
    }

    .course__icon {
        color: $hsl-color-green-58;
        margin-right: 15px;
    }

    .course__name, .billing__link {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .students__button {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        display: flex;
        align-items: center;
        margin-top: 30px;
    }

    .button__icon {
        margin-right: $space-x-small;
    }

    .billing__item {
        margin-top: 30px;
    }

    .billing__item--error {
        color: $hsl-color-red-62;
    }

    .billing__balance {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        @include media($md) {
            flex-direction: row;
        }
    }

    .billing__value {
        font-weight: 500;
    }

    .billing__link {
        margin-top: 10px;
        @include media($md) {
            margin-top: 0;
        }
    }

    .billing__month-payment {
        display: flex;
        justify-content: space-between;
        align-items: center;
        @include media($md) {
            justify-content: flex-start;
        }
    }

    .month-payment__cost {
        display: flex;
        flex-direction: column;
        @include media($md) {
            display: block;
        }
    }

    .angle__icon {
        margin-left: 10px;
        color: $hsl-color-blue-56;
    }

    .angle__icon--inverse {
        transform: rotate(0.5turn);
    }

    .month-payment, .date-of-next-payment  {
        margin-top: 30px;
    }

    .month-payment__wrapper {
        overflow-x: auto;
        max-width: inherit;
    }

    .month-payment__table {
        margin: 30px 0px;
        width: calc(100% + 60px);
        text-align: left;
        border-collapse: collapse;
        @include media($md) {
            width: 100%;
        }
    }

    .month-payment__thead {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        background-color: #E6E6F8;
    }

    .month-payment__td {
        padding: 13px 12px;
        @include media($md) {
            padding: 10px 30px;
        }
    }

    .month-payment__tr--border {
        border-bottom: 1px solid #E6E6F8;
    }

    .zero-forks-modal__text {
        margin-top: 30px;
    }

    .slide-enter-active {
        transition-duration: 0.3s;
        transition-timing-function: ease-in;
    }

    .slide-leave-active {
        transition-duration: 0.3s;
        transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    }

    .slide-enter-to, .slide-leave {
        max-height: 1000px;
        overflow: hidden;
    }

    .slide-enter, .slide-leave-to {
        overflow: hidden;
        max-height: 0;
    }

</style>
